module.exports = __webpack_public_path__ + "static/Banner-19-9967d3058e8984731c882eca4b645315.png";